module.exports = __webpack_public_path__ + "img/C4M.77109612.png";